import { useMutation, useQueryClient } from '@tanstack/react-query';

import { parseApiError, getApiClient } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { useOrganizations } from '@cast/shared-organization-context-data-access';

import { getTrialStatusQueryKey } from './useTrialStatusQuery';

export const useStartTrialMutation = () => {
  const queryClient = useQueryClient();
  const { currentOrganization } = useOrganizations();
  const organizationId = currentOrganization?.id;

  return useMutation({
    mutationFn: () =>
      getApiClient().plgTrial.startTrial({
        organizationId: organizationId!,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getTrialStatusQueryKey(organizationId),
      });
    },
    onError: (error) => {
      notify.error(parseApiError(error));
    },
  });
};
